module.exports = __webpack_public_path__ + "img/01.4d91d188.png";